import React from "react";
import { Box, Chip, Typography } from "@mui/material";

/**
 * Displays the selected countries as chips
 */
const SelectedCountriesDisplay = ({ 
  selectedCountries = [], 
  totalCountries = 0 
}) => {
  if (!selectedCountries || selectedCountries.length === 0) return null;

  const displayLabel =
    selectedCountries.length === totalCountries
      ? "All Countries"
      : `Selected Countries (${selectedCountries.length})`;

  return (
    <Box sx={{ flex: 1, minWidth: "250px" }}>
      <Typography
        variant="caption"
        sx={{
          color: "#888",
          fontSize: "0.75rem",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.8px",
          display: "block",
          marginBottom: "10px",
        }}
      >
        {displayLabel}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", minHeight: "40px" }}>
        {selectedCountries.slice(0, 10).map((country, index) => (
          <Chip
            key={index}
            label={country}
            size="small"
            sx={{
              backgroundColor: "#e3f2fd",
              color: "#1565c0",
              fontWeight: 500,
              fontSize: "0.8rem",
              border: "1px solid #bbdefb",
              height: "28px",
            }}
          />
        ))}
        {selectedCountries.length > 10 && (
          <Chip
            label={`+${selectedCountries.length - 10} more`}
            size="small"
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#666",
              fontWeight: 500,
              fontSize: "0.8rem",
              border: "1px solid #e0e0e0",
              height: "28px",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default SelectedCountriesDisplay;
